import * as Types from '../generated/graphql';

import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
const defaultOptions = {} as const;
export type GetDeviceStatusActivityQueryVariables = Types.Exact<{
  installedProductId: Types.Scalars['String']['input'];
}>;


export type GetDeviceStatusActivityQuery = { __typename?: 'query_root', get_device_status_activity?: Array<{ __typename?: 'DeviceStatusActivityItem', id: string, event_state: string, event_timestamp: any } | null> | null };


export const GetDeviceStatusActivityDocument = gql`
    query getDeviceStatusActivity($installedProductId: String!) {
  get_device_status_activity(installed_product_id: $installedProductId) {
    id
    event_state
    event_timestamp
  }
}
    `;

/**
 * __useGetDeviceStatusActivityQuery__
 *
 * To run a query within a React component, call `useGetDeviceStatusActivityQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetDeviceStatusActivityQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetDeviceStatusActivityQuery({
 *   variables: {
 *      installedProductId: // value for 'installedProductId'
 *   },
 * });
 */
export function useGetDeviceStatusActivityQuery(baseOptions: Apollo.QueryHookOptions<GetDeviceStatusActivityQuery, GetDeviceStatusActivityQueryVariables> & ({ variables: GetDeviceStatusActivityQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetDeviceStatusActivityQuery, GetDeviceStatusActivityQueryVariables>(GetDeviceStatusActivityDocument, options);
      }
export function useGetDeviceStatusActivityLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetDeviceStatusActivityQuery, GetDeviceStatusActivityQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetDeviceStatusActivityQuery, GetDeviceStatusActivityQueryVariables>(GetDeviceStatusActivityDocument, options);
        }
export function useGetDeviceStatusActivitySuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetDeviceStatusActivityQuery, GetDeviceStatusActivityQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetDeviceStatusActivityQuery, GetDeviceStatusActivityQueryVariables>(GetDeviceStatusActivityDocument, options);
        }
export type GetDeviceStatusActivityQueryHookResult = ReturnType<typeof useGetDeviceStatusActivityQuery>;
export type GetDeviceStatusActivityLazyQueryHookResult = ReturnType<typeof useGetDeviceStatusActivityLazyQuery>;
export type GetDeviceStatusActivitySuspenseQueryHookResult = ReturnType<typeof useGetDeviceStatusActivitySuspenseQuery>;
export type GetDeviceStatusActivityQueryResult = Apollo.QueryResult<GetDeviceStatusActivityQuery, GetDeviceStatusActivityQueryVariables>;